import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import getEnv from 'App/Root/getEnv'
import logo from '../../../icons/isotipo-orionx.svg'

const Logo = ({ to = '/' }) => (
  <div className="flex items-center">
    <Link className="flex justify items-center" to={to}>
      <img src={logo} className="h-[30px]" alt="logo" />
    </Link>
    {getEnv() !== 'prod' && <span>&nbsp;{getEnv()}</span>}
  </div>
)

Logo.propTypes = {
  to: PropTypes.string,
}

export default Logo
